import React from "react";
import { useTranslation } from "react-i18next";

import { scrollToTop } from "@utils/scrollUtils";
import { navLinks } from "@constants/navLinks";

import IconButton from "@components/toolkit/IconButton/IconButton";

import NavbarLink from "../NavbarLink/NavbarLink";
import "./MobileMenu.scss";

interface MobileMenuProps {
  onClose?(): void;
}

const MobileMenu = ({ onClose = () => {} }: MobileMenuProps) => {
  const { t } = useTranslation("landing");

  const handleScrollToTop = () => {
    onClose();
    scrollToTop();
  };

  return (
    <div className="mobile-menu">
      <div className="mobile-menu__header">
        <button onClick={handleScrollToTop}>
          <img
            src="/images/branding/finder-ai-signet.png"
            alt="Finder AI - AI search tool interface helping users quickly find and summarize relevant information from websites, social media, and chat platforms"
            width={24}
            height={29}
            className="mobile-menu-signet"
          />
        </button>

        <IconButton onClick={onClose} className="close-menu-btn">
          <img src="/images/icons/close-icon.svg" alt="Close menu" height={24} width={24} />
        </IconButton>
      </div>

      <div className="mobile-menu__main">
        <div className="menu-links">
          {navLinks.map(({ tKey, sectionID, offsetTopDesktop, offsetTopMobile }, index) => {
            return (
              <NavbarLink
                key={index}
                sectionID={sectionID}
                offsetTopDesktop={offsetTopDesktop}
                offsetTopMobile={offsetTopMobile}
                onClick={onClose}
              >
                {t(tKey as any)}
              </NavbarLink>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
